var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0286 6.7859C13.0286 7.45346 12.794 8.06807 12.4016 8.56065C13.1304 9.13794 13.6 10.009 13.6 10.9897V11.1392C13.6 12.9007 12.0952 14.2992 10.2743 14.2992H5.72143C5.33724 14.2992 5 13.9996 5 13.5984V4.3715C5 3.98665 5.32438 3.69922 5.69143 3.69922H9.91857C11.6187 3.69922 13.0286 5.00316 13.0286 6.64732V6.7859ZM12.2029 8.78598C12.1233 8.72367 12.0404 8.66512 11.9543 8.61063C12.0265 8.53908 12.0945 8.46374 12.158 8.38498C12.5162 7.94025 12.7286 7.38612 12.7286 6.7859C12.7286 7.49243 12.4343 8.13509 11.9543 8.61063C12.7657 9.12422 13.2998 9.99791 13.2998 10.9898C13.2998 10.1031 12.8731 9.31094 12.2029 8.78598ZM6.97143 5.60357H9.88143C10.5574 5.60357 11.0571 6.09728 11.0571 6.65275V6.78183C11.0571 7.33595 10.5559 7.83101 9.88143 7.83101H6.97143V5.60357ZM11.6086 11.1378C11.6086 11.8089 11.0227 12.3854 10.2586 12.3854H6.97143V9.74351H10.2586C11.0227 9.74351 11.6086 10.3199 11.6086 10.9911V11.1378Z",
    fill: "#100D40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.db6d60cd15d63ae25cbf7fb5ad6d57fc.svg";
export { ForwardRef as ReactComponent };